export default __webpack_public_path__ + "static/media/Leaders_BG-03.8e4c7c09.png";